import React from 'react';
import { FormattedMessage } from 'react-intl';
import { messages } from '../../messages';

import style from '../common.module.less';

export const FormIsFreeInput = (criterionStateMethods) => {
  const { updateCriterionArgument, getCriterionArgument } = criterionStateMethods;
  const selectedArgument = getCriterionArgument();
  const argumentValue = selectedArgument ? selectedArgument.value : '';
  return (
    <div className={style['form-criteria-section']}>
      <input
        className={style['free-text-input']}
        onChange={(e) => updateCriterionArgument({ value: e.target.value })}
        value={argumentValue}
      />
      <div className={style['free-text-subheader']}>
        <FormattedMessage {...messages.freeTextSubHeader} />
      </div>
    </div>
  );
};
